import React, { useContext } from "react";
import statusCodes from "constants/statusCodes";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import { Shimmer } from "../../server/components/Shimmer";
import { ApplicationContext } from "wrapper/ApplicationWrapper/context";
import { getShimmerServerConfig } from "../../server/helpers";
import { DEVICE_TYPE } from "constants/index";


const Loader = () => {
  const { applicationData } = useContext(ApplicationContext);
  const deviceType = applicationData?.deviceType;

  const ShimmerConfig = getShimmerServerConfig({ url: window?.location?.href });
  const headerTitle = ShimmerConfig.headerTitle;
  const hideShimer = ShimmerConfig.hideShimmer;
  const isSingleCheckoutPage = ShimmerConfig.isSingleCheckoutPage;


  return !hideShimer ? (
    <Shimmer
      isDesktop={deviceType === DEVICE_TYPE.DESKTOP}
      headerTitle={headerTitle}
      pageUrl={""}
      isSingleCheckoutPage = {isSingleCheckoutPage}
    />
  ) : (
    <></>
  );
};

const RouteWithSubRoutes = ({ routes }: { routes: [PageRoute] }) => (
  <Switch>
    {routes?.map((route, key) => (
      <Route
          key={key}
          path={route.path}
          exact={route.exact}
          render={(props: RouteComponentProps) => {
            if (route.status === statusCodes.NOT_FOUND && props.staticContext) {
              props.staticContext.statusCode = route.status;
            }
            return (
              <route.component
                routes={route.routes} // needed for nested routes
                {...props}
                fallback={<Loader />}
              />
            );
          }}
        />
      ))}
  </Switch>
  );

export default RouteWithSubRoutes;
